// src/index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

function mountInto(el) {
  console.log('[FridgeList] mounting into', el);
  const root = ReactDOM.createRoot(el);
  root.render(<App />);
}

(function waitForRoot() {
  const el = document.getElementById('root');
  if (el) {
    mountInto(el);
  } else {
    // Log once every second so we can see it’s trying
    if (!window.__rootWarned) {
      window.__rootWarned = true;
      console.warn('[FridgeList] #root not found yet. Waiting for DOM…');
    }
    setTimeout(waitForRoot, 50);
  }
})();

// Keep SW disabled while we stabilise
// if ('serviceWorker' in navigator) {
//   window.addEventListener('load', () => {
//     navigator.serviceWorker.register('/sw.js').catch(console.error);
//   });
// }